<template>
    <h1>Envois</h1>
    <div class="container-selection-Lot">
        <h2>
            Selection des lots
            <span v-if="resGetLots && resGetLots.length">[{{resGetLots.length}} lot(s)]</span>
            <span v-else>[Aucun lot trouvé]</span>
        </h2>
        <div class="component-selection-Lot">
            <div class="container-checkBox-Lot">

                <label for="myCheckbox">
                    <input type="checkbox" id="myCheckbox1" v-model="ckLot1" @click="changement" />
                    A envoyer
                </label>

                <label for="myCheckbox">
                    <input type="checkbox" id="myCheckbox1" v-model="ckLot2" @click="changement" />
                    Différés
                </label>

                <label for="myCheckbox">
                    <input type="checkbox" id="myCheckbox1" v-model="ckLot4" @click="changement" />
                    Acceptés / Traités
                </label>

                <label for="myCheckbox">
                    <input type="checkbox" id="myCheckbox1" v-model="ckLot3" @click="changement" />
                    Envoyés (ou à réenvoyer)
                </label>

                <label for="myCheckbox">
                    <input type="checkbox" id="myCheckbox1" v-model="ckLot5" @click="changement" />
                    Refusés / A Traiter
                </label>
            </div>
            <div class="container-input-Lot">
                <label> Praticien : <input type="text" placeholder="" v-model="cPrat" @input="changement"></label>
                <label> N° lot : <input type="text" placeholder="" v-model="cNoLot" @input="changement"></label>
            </div>
        </div>
    </div>
    <div class="component-tab-Lot">
        <table>
            <thead>
                <tr>
                    <th>N°Lot:</th>
                    <th>Praticien</th>
                    <th>Nbre FSE</th>
                    <th>Etat</th>
                    <th>Date dernier envoi</th>
                    <th>Description du traitement</th>
                    <th>Sujet du message</th>
                    <th>Destinataire</th>
                    <th></th>
                    <!--<th>Sél</th>-->
                </tr>
            </thead>
            <tbody>
                <tr v-for="obj in resGetLots" :key="obj.NoLot">
                    <td>{{obj.NoLot}}</td>
                    <td>{{obj.Praticien}}</td>
                    <td>{{obj.NoFse}}</td>
                    <td>{{obj.Etat}}</td>
                    <td>{{obj.DateDernierEnvoi}}</td>
                    <td>{{obj.DescriptionDuTraitement}}</td>
                    <td>{{obj.SujetDuMessage}}</td>
                    <td>{{obj.Destinataire}}</td>
                    <td><v-btn @click="lancerLots(obj.NoLot)">Détail du lot</v-btn></td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="component-button-Lot">
        <button class="close-button" v-on:click="Transmettre">Transmettre</button>
        <button class="close-button" v-on:click="retour">Fermer</button>
    </div>
</template>
<style scoped>


    h1 {
        text-align: center;
        color: darkblue;
        margin-bottom: 15px;
    }
    h2 {
        font-size:25px;
        margin-top:10px;
        margin-left:15px;
    }
    .container-selection-Lot {
        border: 1px solid grey;
        margin-bottom: 5px;
        margin-right: 5px;
    }

    .container-checkBox-Lot {
        color: black;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-row-gap: 10px;
    }

    .container-input-Lot {
        display: flex;
        justify-content: space-between;
    }

    .container-input-Lot label {
        flex-basis: 45%;
        margin-bottom: 10px;
    }

    .container-input-Lot input,
    .container-input-Lot select {
        width: 100%;
        padding: 5px;
    }

    .component-selection-Lot {
        display: grid;
        grid-template-columns: 1fr 1fr;
        background-color: white;
        border: 1px solid grey;
        padding: 10px;
        margin: 10px;
    }


    .component-tab-Lot {
        background: white;
        height: 500px;
        overflow-x: auto; /* le tableau defile horizontalement au lieu de deborder la page */
        -webkit-overflow-scrolling: touch;
    }

    .component-tab-Lot table {
        border-collapse: collapse;
        width: 100%;
    }

    .component-tab-Lot th, td {
        padding: 12px;
        text-align: left;
    }

    .component-tab-Lot th {
        /*background-color: #f2f2f2;*/
        background: #004AAD;
        color: #333;
        font-weight: bold;
        color: white;
    }

    .component-tab-Lot tr:hover {
        background: #CDE0ED;
    }

    /* Optionnel : Style pour la première ligne d'en-tête */
    .component-tab-Lot thead th {
        border-top: none;
    }
    .component-button-Lot {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px; /* Ajustez la marge supérieure selon vos besoins */
        position: fixed;
        bottom: 0px;
        right: 0px;
    }

    .close-button {
        margin: 15px;
        padding: 8px 16px;
        border: none;
        border-radius: 4px;
        background-color: #004AAD;
        color: white;
        font-size: 16px;
        font-weight: bold;
        text-transform: uppercase;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    .close-button:hover {
        background-color: lightblue;
    }

    .close-button:active {
        background-color: lightblue;
        outline: none; /* Pour enlever la bordure bleu */
    }
    @media screen and (max-width: 800px) {
        .container-input-Lot {
            display: grid;
            grid-template-rows: 1fr 1fr;
        }
        .container-checkBox-Lot {
            color: black;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-row-gap: 10px;
        }
        /* Largeur mini pour garder le tableau lisible : il defile dans son
           conteneur (.component-tab-Lot) au lieu d'etirer la page. */
        .component-tab-Lot table {
            min-width: 700px;
        }
    }
</style>
<script>
    import { defineComponent } from 'vue';
    import FSEWithInfo from '../script/FSEWithInfo.js';
    import RequestManager from '../script/request.js';
    import config from '../config.js';
    export default defineComponent({
        data: function () {
            return {
                message: 'Bienvenu dans la page choix TransCam !',
                resGetLots: [],
                ckLot1: true,
                ckLot2: true,
                ckLot3: true,
                ckLot4: false,
                ckLot5: true,
                cNoLot: "",
                cPrat: "",
                bSelectChange: true
            }
        },

        computed: {

        },

        methods: {
            retour() {
                console.log("regarde")
                history.back();
            },

            Transmettre() {
                let lisFse = [20,21];
                FSEWithInfo.transmettreFse(lisFse)
            },

            changement() {
                this.bSelectChange = true;
            },

            sendCkLotStates() {
                var url = config.urlBackEnd + "Lot/MajGet3";
                if (this.bSelectChange) { 
                    RequestManager.post(url, {
                        "ckLot1": this.ckLot1,
                        "ckLot2": this.ckLot2,
                        "ckLot3": this.ckLot3,
                        "ckLot4": this.ckLot4,
                        "ckLot5": this.ckLot5,
                        "cNoLot": this.cNoLot,
                        "cPrat": this.cPrat
                    })
                    .then(response => {
                        this.resGetLots = response;
                    })
                    .catch(error => {
                        console.error('Erreur lors de l\'envoi des données au backend:', error);
                    });
                    this.bSelectChange = false;
                }
            },
            lancerLots(NoLot) {
                window.open(this.$router.resolve({ name: 'Lots', query: { NoLot } }).href, '_blank');
                /*this.$router.push({ name: 'Lots', query: { NoLot } });*/
            }
        },

        props: {
            
        },

        mounted() {
            setInterval(this.sendCkLotStates, 1000);
        }

    });
</script>